import plugin_routes from './plugin_routes';
import Error404 from '../pages/Error404.vue';
const routes = [
    {
        path: '/',
        component: () => import('src/pages/layouts/MainLayout.vue'),
        children: [
            {
                path: '',
                name: 'index',
                // component: () => import('src/pages/IndexPause.vue'),
                component: () => import('src/pages/Index.vue'),
            },
            {
                path: 'pretest',
                name: 'home',
                // component: () => import('src/pages/IndexPause.vue'),
                component: () => import('src/pages/Index.vue'),
            },
            {
                path: 'moderation',
                name: 'moderation',
                component: () => import('src/pages/Moderation.vue'),
            },
            {
                path: '/authorization',
                props: true,
                name: 'authorization',
                component: () => import('src/pages/Empty.vue'),
            },
            {
                path: '/logout',
                name: 'logout',
                component: () => import(/* webpackPrefetch: true */ 'src/pages/Auth/Logout.vue'),
            },
            // Encypted Pin (eg.g QC)
            {
                path: '/t/:ttoken',
                name: 'tokenlogin',
                component: () => import('src/utils/VueOAuth2PKCE/TokenLogin.vue'),
            },
            // Email Token
            {
                path: '/l/:ltoken',
                name: 'ltokenlogin',
                component: () => import('src/utils/VueOAuth2PKCE/TokenLogin.vue'),
            },
            {
                path: '/sekretariat',
                name: 'profile',
                props: true,
                component: () => import(/* webpackPrefetch: true */ 'src/pages/Auth/Profile.vue'),
            },
            {
                path: '/pause',
                name: 'pause',
                component: () => import(/* webpackPrefetch: true */ 'src/pages/Construction.vue'),
            },
            {
                path: '/impressum',
                name: 'impressum',
                component: () => import(/* webpackPrefetch: true */ 'src/pages/Impressum.vue'),
            },
            {
                path: '/verhaltenskodex',
                name: 'verhaltenskodex',
                component: () => import(/* webpackPrefetch: true */ 'src/pages/Verhaltenskodex.vue'),
            },
            {
                path: '/feedback',
                name: 'feedback',
                component: () => import(/* webpackPrefetch: true */ '../pages/Feedback.vue'),
            },
            ...plugin_routes,
            { path: '/:pathMatch(.*)*', name: 'NotFound', component: Error404 },
        ],
    },
];
// console.log(routes, 'DEBUG ROUTES..');
export default routes;
